import { AnalyticsMetaKeys as key } from '../../../../services/analytics/formatters/meta-keys'
import { Krux } from '../../../../services/analytics/tags/krux'
import { KruxEvent } from '../../../../services/common/events/krux'
import { AnalyticsEvent, IKruxControlFields } from '../../event'
import { GlobalDataFormatter } from '../global-data'

export class KruxProvider extends AnalyticsEvent {

    private data: any
    private commonAttrs = [
        key.ENV
    ]
    private kruxKeysMapping: any = {
        article_authors: 'Authors',
        article_tags: 'Tags',
        article_title: 'Article Title',
        env: 'Env',
        metered_content: 'Paywall Whitelist',
        sponsor_name: 'Sponsor'
    }

    public constructor(data: any, type: string, value: string, action: string, element: Element) {
        super(type, value, action, element)
        this.data = data
    }

    /**
     * Handle event
     */
    public handle(): void {

        /**
         * Event Handler: updates the attributes list and sends it to mParticle
         * @var data will be different for each event
         *
         */

        const krux = new Krux()

        let eventData: any = { ...this.data }  // extra data common to all providers

        const dataAttrs = this.getProviderAttributesList('krux', this.commonAttrs)
        // Get Data Values ( this.metaProperties this is data coming from page-data )
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '') {
                    eventData[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error in class KruxProvider', e)
            }
        })

        const customData = this.getProviderCustomData('krux')

        eventData = {
            ...eventData,
            ...customData
        }

        const kruxData: IKruxControlFields = this.getProviderControlField('krux')

        // Update keys names
        for(const mappedKey in this.kruxKeysMapping) {
            if (mappedKey in eventData) {
                eventData[this.kruxKeysMapping[mappedKey]] = eventData[mappedKey]
                delete eventData[mappedKey]
            }
        }

        if (this.action === 'page-load') {
            dispatchEvent(new CustomEvent(KruxEvent.FIRE_PAGE_VIEW, {
                detail: eventData
            }))
        } else if (this.action === 'load') {
            // update krux data layer and send async tag
            krux.sendAsyncView(eventData)
        } else if (kruxData.krx_event_id) {
            const kruxEventDataWithAttributes = {
                ...eventData,
                event_id: kruxData.krx_event_id,
                event_type: kruxData.krx_event_type || 'default'
            }
            // send Krux event with attributes
            krux.sendEvent(kruxEventDataWithAttributes)
        }
    }
}
